// leading debounce
// TODO write test

// created() {
//     this.wrapper = _.debounce(this.checkThisContext);
//     this.wrapper(1);
//     this.wrapper(2);
//     this.wrapper(3);
//     setTimeout(this.wrapper, 1000);
// },
// methods: {
//     checkThisContext(n) {
//         console.log('checkThisContext', n, this);
//     },
// },

/**
 * Debounce a function
 * @param {Function} func delegate to call
 * @param {number} delay amount of milliseconds to debounce
 * @param {boolean} immediate whether to run the first call immediately or
 * only after all timers complete
 * @returns {wrapper<Function>}
 */
export default function debounce(func, delay, immediate = true) {
    let timeout;
    let called = false;

    return function wrapper(...args) {
        const handler = () => {
            called = true;
            func.apply(this, [...args]);
        };
        const timer = () => {
            timeout = null;
            if (!called) {
                handler();
            }
        };

        // delayed or first run
        if (!timeout && immediate) {
            handler();
        } else {
            called = false;
        }
        clearTimeout(timeout);
        timeout = setTimeout(timer, delay);
    };
}
